export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选高分影视作品，蓝光超清画质呈现
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=epic%20sci-fi%20movie%20scene%20with%20spaceship%20and%20stars%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20film%20poster%20style%2C%20professional%20cinematography%2C%20no%20text&width=640&height=360&seq=media-01-97&orientation=landscape"
                alt="星际征途：新纪元"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-xs text-background-50">
                <span className="bg-accent-500 px-2 py-0.5 rounded-full whitespace-nowrap">科幻冒险</span>
                <span>2h 18m</span>
              </div>
              <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-background-50">
                <i className="ri-play-fill text-lg"></i>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors">星际征途：新纪元</h3>
              <p className="text-xs text-foreground-500 mb-2">人类文明在宇宙深处的最后希望，一场跨越星系的史诗冒险</p>
              <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-eye-line"></i>128万 次播放</span>
            </div>
          </div>

          <div className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20noir%20crime%20scene%20with%20rainy%20alley%20and%20detective%20silhouette%2C%20suspenseful%20cinematic%20lighting%2C%20deep%20shadows%20with%20golden%20street%20light%2C%20film%20noir%20aesthetic%2C%20professional%20cinematography%2C%20no%20text%20no%20people&width=640&height=360&seq=media-02-97&orientation=landscape"
                alt="暗夜追踪者"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-xs text-background-50">
                <span className="bg-accent-500 px-2 py-0.5 rounded-full whitespace-nowrap">悬疑犯罪</span>
                <span>1h 52m</span>
              </div>
              <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-background-50">
                <i className="ri-play-fill text-lg"></i>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors">暗夜追踪者</h3>
              <p className="text-xs text-foreground-500 mb-2">连环案件背后的惊天阴谋，每一个细节都可能是破局关键</p>
              <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-eye-line"></i>96万 次播放</span>
            </div>
          </div>

          <div className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=ancient%20Chinese%20palace%20cityscape%20at%20dusk%2C%20lanterns%20glowing%20warm%20golden%20light%2C%20historical%20drama%20setting%2C%20cinematic%20composition%20with%20rich%20warm%20tones%2C%20Tang%20dynasty%20aesthetic%2C%20no%20text%20no%20people&width=640&height=360&seq=media-03-97&orientation=landscape"
                alt="长安十二时辰"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-xs text-background-50">
                <span className="bg-accent-500 px-2 py-0.5 rounded-full whitespace-nowrap">古装历史</span>
                <span>48集</span>
              </div>
              <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-background-50">
                <i className="ri-play-fill text-lg"></i>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors">长安十二时辰</h3>
              <p className="text-xs text-foreground-500 mb-2">盛世长安暗流涌动，忠义之士誓死守护黎明前的最后希望</p>
              <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-eye-line"></i>215万 次播放</span>
            </div>
          </div>

          <div className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=fast%20racing%20car%20on%20neon%20lit%20city%20street%20at%20night%2C%20motion%20blur%20effect%2C%20action%20cinematic%20lighting%20with%20warm%20orange%20and%20red%20tones%2C%20adrenaline%20racing%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=640&height=360&seq=media-04-97&orientation=landscape"
                alt="极限速度：疾风"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-xs text-background-50">
                <span className="bg-accent-500 px-2 py-0.5 rounded-full whitespace-nowrap">动作竞速</span>
                <span>2h 05m</span>
              </div>
              <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-background-50">
                <i className="ri-play-fill text-lg"></i>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors">极限速度：疾风</h3>
              <p className="text-xs text-foreground-500 mb-2">地下赛车世界的光荣与梦想，速度与激情的极致碰撞</p>
              <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-eye-line"></i>87万 次播放</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}